import { jsx } from 'react/jsx-runtime';
import { Text } from '@dls/web';
import { ROUTES } from '../../../../helpers/constants.js';
import Anchor from '../../../Anchor/index.js';
import theme from '../../../../theme/index.js';
const Logout = _ref => {
  let {
    url = ROUTES.logout,
    theme: theme$1,
    onClick
  } = _ref;
  return /* @__PURE__ */jsx(Anchor, {
    href: url,
    onClick,
    ariaLabel: "Logout",
    children: /* @__PURE__ */jsx(Text, {
      type: "smallBody",
      fontWeight: "bold",
      style: {
        color: theme$1 === "dark" || theme$1 === "red" ? theme.colours.white : theme.colours.black
      },
      children: "Sign out"
    })
  });
};
export { Logout as default };